"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerAnalyticsFormStepEvent = exports.triggerAnalyticsFormStartEvent = exports.triggerAnalyticsFormComplete = exports.triggerAnalyticsErrorEvent = exports.default = void 0;
exports.validateFormAnalyticsRequirements = validateFormAnalyticsRequirements;
var _alloyAnalytics = _interopRequireWildcard(require("@telus/alloy-analytics"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function formatString(string) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return string ? string.toLowerCase().replace(/([ ])/g, separator) : '';
}
function validateFormAnalyticsRequirements(formMetaData) {
  var {
    analyticsFormName,
    analyticsFormType: formType,
    analyticsFormLob: lob
  } = formMetaData;
  if (!analyticsFormName) {
    return false;
  }
  if (formType === _constants.ANALYTICS_FORM_TYPES.LEAD && !lob) {
    return false;
  }
  return true;
}
function canFormStartEventBeTriggered(formMetaData) {
  var _window, _formMetaData$fields, _window$adobeDataLaye;
  if (((_window = window) === null || _window === void 0 ? void 0 : _window.adobeDataLayer) === undefined) {
    return true;
  }
  var formDataIsReady = (formMetaData === null || formMetaData === void 0 || (_formMetaData$fields = formMetaData.fields) === null || _formMetaData$fields === void 0 ? void 0 : _formMetaData$fields.length) > 0;
  if (!formDataIsReady) {
    return false;
  }
  var existingEvents = (_window$adobeDataLaye = window.adobeDataLayer) !== null && _window$adobeDataLaye !== void 0 ? _window$adobeDataLaye : [];
  var eventMatches = existingEvents.filter(event => event.event === 'formStart');
  var formStartEventExists = eventMatches.length === 0;
  return formStartEventExists;
}
var triggerAnalyticsFormStartEvent = formMetaData => {
  var canBeTriggered = canFormStartEventBeTriggered(formMetaData);
  if (!canBeTriggered) {
    return;
  }
  var {
    analyticsFormName: formName,
    analyticsFormType: formType,
    analyticsFormLob: lob,
    analyticsLeadId: leadID,
    id: formID
  } = formMetaData;
  if (formType === _constants.ANALYTICS_FORM_TYPES.LEAD && !lob) {
    throw new Error('[Analytics] LOB is required for Lead forms');
  }
  var eventProperties = formType === _constants.ANALYTICS_FORM_TYPES.FORM ? {
    name: "formbuilder_".concat(formatString(formName), "_start")
  } : {
    name: "formbuilder_".concat(formatString(formName), "_lead_start"),
    leadType: "formbuilder_".concat(formatString(lob)),
    isLead: true,
    leadID
  };
  var webInteractionData = _objectSpread(_objectSpread({}, eventProperties), {}, {
    formID,
    formName: "formbuilder_".concat(formatString(formName))
  });
  _alloyAnalytics.default.event('formStart').webInteraction(webInteractionData).fire();
};
exports.triggerAnalyticsFormStartEvent = triggerAnalyticsFormStartEvent;
var triggerAnalyticsFormStepEvent = _ref => {
  var {
    formMetaData,
    currentStep,
    fieldData
  } = _ref;
  var {
    analyticsFormName,
    analyticsFormType: formType,
    analyticsFormLob: lob,
    analyticsLeadId: leadID,
    analyticsLeadType: leadType,
    id: formID
  } = formMetaData;
  if (formType === _constants.ANALYTICS_FORM_TYPES.LEAD && !lob) {
    throw new Error('[Analytics] LOB is required for Lead forms');
  }
  var stepTracker = formMetaData.fields.find(field => field.type === _constants.FIELD_TYPES.STEP_TRACKER_FIELD);
  if (!stepTracker) return;
  var {
    label: stepName,
    fields: stepFields
  } = stepTracker.steps[currentStep];
  var stepNumber = currentStep + 1;
  var toolSelections = stepFields.filter(field => !field.containsPII && (field.type === _constants.FIELD_TYPES.DROPDOWNLIST_FIELD || field.type === _constants.FIELD_TYPES.RADIOBUTTON_FIELD || field.type === _constants.FIELD_TYPES.CHECKBOX_FIELD)).map(field => {
    var _fieldData$current$fi;
    var value = ((_fieldData$current$fi = fieldData.current[field.id]) === null || _fieldData$current$fi === void 0 ? void 0 : _fieldData$current$fi.value) || '';
    var formQuestion = (0, _alloyAnalytics.stringFormatter)(field.label);
    var formattedValue = Array.isArray(value) ? "[".concat(value.join(','), "]") : value;
    var formResponse = (0, _alloyAnalytics.stringFormatter)(formattedValue);
    return "".concat(formQuestion, ":").concat(formResponse);
  }).join(',');
  var formName = formatString(analyticsFormName);
  _alloyAnalytics.default.event('formStep').webInteraction(_alloyAnalytics.default.applyValues({
    key: formType,
    base: {
      formID,
      formName: "formbuilder_".concat(formName),
      formStepName: "".concat(formName, "_").concat(stepName, "_form:step_").concat(stepNumber),
      stepNumber,
      toolSelections
    },
    cases: {
      form: {
        name: "formbuilder_".concat(formName, "_regular_form:step_").concat(stepNumber)
      },
      lead: {
        leadID,
        leadType,
        name: "formbuilder_".concat(formName, "_lead_form:step_").concat(stepNumber)
      }
    }
  })).fire();
};
exports.triggerAnalyticsFormStepEvent = triggerAnalyticsFormStepEvent;
var triggerAnalyticsFormComplete = (payload, submissionId, adapterResponseArray) => {
  var _fields$find;
  var {
    analyticsFormName: formName,
    analyticsFormType: formType,
    analyticsFormLob: lob,
    id: formID,
    fields,
    consentField
  } = payload;
  if (formType === 'lead' && !lob) {
    throw new Error('[Analytics] LOB is required for Lead forms');
  }
  var toolSelections = fields.filter(_ref2 => {
    var {
      type
    } = _ref2;
    return type === 'checkboxField' || type === 'dropdownListField' || type === 'radioButtonField';
  }).map(_ref3 => {
    var {
      label,
      value
    } = _ref3;
    var fieldValue = Array.isArray(value) ? "[".concat(value.join(','), "]") : value;
    return "".concat(formatString(label, '_'), ":").concat(formatString(fieldValue, '_'));
  });
  if (consentField && consentField.length > 0) {
    var consentOptions = consentField[0].consentOptions;
    if (consentOptions && consentOptions.length > 0) {
      consentOptions.forEach(option => option && option.entryTitle && typeof option.entryTitle === 'string' && toolSelections.push("".concat(formatString(option.entryTitle), ":checked")));
    } else {
      var label = consentField[0].entryTitle && typeof consentField[0].entryTitle === 'string' ? formatString(consentField[0].entryTitle) : '';
      toolSelections.push("".concat(label, ":checked"));
    }
  }
  var eventProperties = formType === 'form' ? {
    name: "formbuilder_".concat(formatString(formName), "_formComplete")
  } : {
    name: "formbuilder_".concat(formatString(formName), "_lead_formComplete"),
    leadType: "formbuilder_".concat(formatString(lob)),
    isLead: true,
    leadID: submissionId
  };
  _alloyAnalytics.default.event('formComplete').webInteraction(_objectSpread(_objectSpread({}, eventProperties), {}, {
    formID,
    formAdapter: adapterResponseArray.map(_ref4 => {
      var {
        adapter
      } = _ref4;
      return adapter;
    }).join('|'),
    toolSelections: toolSelections.join(','),
    formName: "formbuilder_".concat(formatString(formName)),
    email: (_fields$find = fields.find(field => field.type === _constants.FIELD_TYPES.EMAIL_FIELD)) === null || _fields$find === void 0 ? void 0 : _fields$find.value
  })).fire();
};
exports.triggerAnalyticsFormComplete = triggerAnalyticsFormComplete;
var triggerAnalyticsErrorEvent = exports.triggerAnalyticsErrorEvent = function triggerAnalyticsErrorEvent(formMetaData, type, message) {
  var code = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'n/a';
  var {
    analyticsFormName: formName,
    id: formID
  } = formMetaData;
  var errorType;
  switch (type) {
    case _constants.ANALYTICS_ERROR_TYPES.FIELD_COMPLETION:
      errorType = 'user';
      break;
    case _constants.ANALYTICS_ERROR_TYPES.SUBMISSION:
      errorType = 'api';
      break;
    case _constants.ANALYTICS_ERROR_TYPES.FORM_LOAD:
      errorType = 'api';
      break;
    case _constants.ANALYTICS_ERROR_TYPES.PREFILLED:
      errorType = 'system';
      break;
    default:
      errorType = 'system';
  }
  _alloyAnalytics.default.event('errorEvent').webInteraction({
    formID,
    name: "formbuilder_".concat(formatString(formName), "_error"),
    errorType,
    errorDetails: "{formBuilder:[".concat(type, "]}"),
    errorMessage: message,
    errorCode: code
  }).fire();
};
var defaultExport = {
  triggerAnalyticsErrorEvent,
  triggerAnalyticsFormStartEvent
};
var _default = exports.default = defaultExport;